export const LIST_USERS = 'LIST_USERS'
export const CACHE_LIST = 'CACHE_LIST'
export const JOIN_GROUP = 'JOIN_GROUP'
export const SEND_MESSAGE = 'SEND_MESSAGE'
export default {
    LIST_USERS,
    CACHE_LIST,
    JOIN_GROUP,
    SEND_MESSAGE
}